<template>
  <div class="kanban-topbar">

    <div class="kanban-breadcrumb hamburger-spacer">

      <router-link class="pl-2" :to="{ name: 'goal_overview' }">Goals</router-link>

      <span v-for="breadcrumb in path_array" :key="breadcrumb.name">
        <i class="el-icon-arrow-right"></i>
        <router-link :to="breadcrumb.path">{{breadcrumb.name}}</router-link>
      </span>
    </div>

    <div v-if="show_popover" class="kanban-filter-box">
      <show-hide-icon
        :value="kanban_settings.showFinishedTasks"
        @input="onUpdateFilter('showFinishedTasks', $event)">
        Show finished tasks
      </show-hide-icon>
      <show-hide-icon
        :value="kanban_settings.showArchivedTasks"
        @input="onUpdateFilter('showArchivedTasks', $event)">
        Show archived tasks
      </show-hide-icon>
      <show-hide-icon
        v-model="filter.show_unassigned_tasks"
        tooltip-show="Hide unassigned tasks"
        tooltip-hide="Show unassigned tasks">
        Show unassigned tasks
      </show-hide-icon>

      <el-popover
        placement="bottom"
        width="140"
        :open-delay="0"
        trigger="click">
        <color-selector
          class="mt-2 mb-1"
          headline="Filter by label"
          size="small"
          :selected_color="filter.show_label"
          @color-select="onSelectColor" />
        <div slot="reference">
          <font-awesome-icon
            :icon="['fas', 'palette' ]"
            color="white"
            style="outline: 0; width: 32px; cursor: pointer" />
          Filter by label
        </div>
      </el-popover>
      <el-checkbox
        class="p-0 ml-2 mb-0"
        v-if="enable_prop_task_height"
        :value="kanban_settings.showPropTaskHeight"
        @input="onUpdateFilter('showPropTaskHeight', $event)">
        Make long tasks bigger
      </el-checkbox>
      <el-checkbox
        class="p-0 ml-2 mb-0"
        :value="kanban_settings.compactStyle"
        @input="onUpdateFilter('compactStyle', $event)">
        Compact view
      </el-checkbox>
      <!--<el-checkbox
        class="p-0 ml-2 mb-0"
        :value="kanban_settings.columnLayout"
        @input="onUpdateFilter('columnLayout', $event)">
        Column Layout
      </el-checkbox>-->
    </div>

    <template v-if="showFilter">
      <el-input
        v-model="filter.search_text"
        clearable
        placeholder="Search..."
        size="mini"
        class="w-50"></el-input>

      <div style="display: flex; flex: 0 0;">
        <!-- Layout: -->
        <div style="margin-left: 0.5em; cursor: pointer">
          <font-awesome-icon size="lg" :icon="['fas', 'columns']" @click="onUpdateFilter('columnLayout', false)" :color="[ kanban_settings.columnLayout ? ' grey': 'white' ]" />
        </div>
        <div style="margin-left: 0.5em; cursor: pointer">
          <font-awesome-icon size="lg" :icon="['fas', 'th-large']" @click="onUpdateFilter('columnLayout', true)"  :color="[ !kanban_settings.columnLayout ? ' grey': 'white' ]" />
        </div>
      </div>

      <el-button
        type="text"
        @click="show_popover = !show_popover"
        style="color: #ffffff;">
        <font-awesome-icon icon="filter" /> Filter
      </el-button>
    </template>
  </div>
</template>

<script>
// import Vue from 'vue'
import { ENABLE_PROPORTIONAL_TASK_HEIGHTS } from '@/features'

export default {
  props: {
    filter: {},
    goalId: { default: null, },
    showFilter: { default: true },
  },
  data: () => ({
    show_popover: false,
    // show_finished: true,
    // show_archived: false,
    // show_prop_task_height: false,
    // compact_style: false,
    // column_layout: false,
    enable_prop_task_height: ENABLE_PROPORTIONAL_TASK_HEIGHTS
  }),
  watch: {
    // filter: {
    //   handler() {
    //     this.onUpdate()
    //   },
    //   deep: true
    // },
  },
  computed: {
    path_array() {
      let breadcrumbs = [];
      breadcrumbs.push({
        name: this.goal_meta.name,
        path: { name: 'goal', goalId: this.goalId }
      });
      /*
      if ( this.$route.name === 'dashboard' || this.$route.name === 'kanban' ) {
        breadcrumbs.push({
          name: 'Dasboard',
          path: { name: 'goal', goalId: this.goalId }
        });
      }
      */
      if ( this.$route.name === 'settings' ) {
        breadcrumbs.push({
          name: 'Settings',
          path: '/goal/' + this.goalId + '/settings'
        });
      }
      if ( this.$route.name === 'taskpage' ) {
        let task = {}
        if ( this.$route.params.sequenceId ) {
          task.name = 'Sequence';
        } else {
          task = this.$models.task.with({
            goalId: this.$route.params.goalId,
            memberId: this.$route.params.memberId
          }).getNodeFull( this.$route.params.taskId )
          // TODO: Error check
        }

        breadcrumbs.push({
          name: task.name,
          path: this.$route.path
        });
      }
      return breadcrumbs;
    },

    goal_meta() {
      return this.$models.goalMeta.subscribeNode( this.goalId );
    },

    goal_user_settings() {
      return this.$models.userGoalSettings.getNode( this.goalId ) || {};
    },

    kanban_settings() {
      return this.goal_user_settings.kanbanSettings || {};
    },
  },
  methods: {
    onUpdateFilter( prop, value ) {
      return this.goal_user_settings.update({ ['kanbanSettings/' + prop]: value })
    },
    onSelectColor( value ) {
      this.filter.show_label = value === 'default' ? null : value
    },
    onUpdate() {
      // Vue.set(this.filter, 'search_text', this.filter.search_text)
    }
  },
};
</script>

<style>
.kanban-topbar {
  background-color: rgba(47, 47, 47, 0.75);
  color: white;
  display: flex;
  align-content: normal;
  align-items: center;
  height: 50px;
  border-bottom: 1px solid #a5a5a5;
  font-size: 16px;
  justify-content: space-between;
}
.kanban-topbar > * {
  /*display: inline-block;*/
  /*margin: 0;*/
  padding: 0 0.5em;
}
.kanban-topbar .el-input--mini .el-input__inner {
  height: 26px;
  line-height: 26px;
}
.kanban-topbar .el-checkbox {
  color: white !important;
}
.kanban-topbar .el-input__inner,
.kanban-topbar .el-checkbox__inner {
  color: white;
  background-color: #8a8a8a;
}
.kanban-topbar .el-input__suffix {
  right: 13px;
}
.kanban-breadcrumb a {
  color: white;
}
.kanban-topbar .kanban-filter-box {
  border: 1px solid white;
  position: fixed;
  right: 10px;
  top: 40px;
  background-color: rgba(47, 47, 47, 0.75);
  padding: 1em;
  z-index: 9;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 240px;
}
.kanban-topbar .kanban-filter-box > * {
  display: block;
}
.kanban-topbar .kanban-filter-box .el-checkbox__label {
  font-size: 16px;
}
</style>
